import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getAmplifyClient } from '@/services/amplifyClient'
import { updateOrganizationMemberMutation } from '@/services/graphql/team'

const client = getAmplifyClient()

export const useUpdateProjectInvit = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['updateProjectMember'],
    mutationFn: updateProjectMember,
    onSuccess: (
      _data,
      variables: { id: string; seen: boolean; userID: string },
      _context,
    ) => {
      queryClient.refetchQueries({
        queryKey: ['notifications', variables.userID],
      })
    },
  })
}

const updateProjectMember = async ({ id, seen }) => {
  try {
    await client.graphql({
      query: updateOrganizationMemberMutation,
      variables: {
        input: {
          id,
          seen,
        },
      },
    })
  } catch (e) {
    console.error(e)
    throw e
  }
}
